<template>
	<a-modal width="55%" title="详情" :visible="visible" centered :destroy-on-close="true" :mask-closable="false"
		:confirm-loading="confirmLoading" :footer="null" @ok="onSubmit" @cancel="onClose">
			<div v-for="(item,index) in formatDate" :key="index"  :column="2">

				<span v-if="item.type.includes(form.type)" style="width:50%;float:left;margin:10px 0;">
					<span>{{item.label}}: {{getChange(form[item.name],item.metye)}}</span>
				</span>
			</div>



	</a-modal>
</template>
<script>
import { formMixin } from "@/mixins";
export default {
	name: "DetailModal",
	components: {
	},
	methods:{
		getChange(value,metye){
			if(metye==1){
					return value == 0 ?'是':'否';
			}else if(metye==2){
					return this.dics[value];
			}else if(metye==3){
					return this.dics1[value];
			}else if(metye==4){
					return this.dics2[value];
			}else{
				return value
			}
		}
	},

	mixins: [formMixin],
	data() {
		return {
			dics:['无','国家级','省级','市级'],
			dics1:['无','一等奖','二等奖','三等奖','入围决赛'],
			dics2:['无','国家级','地方'],
			formatDate:[
				{
					label:"去年营业收入规模(万元)",
					name:'operatingIncome',
					type:"A,B,C,D",
					ifChange:false,
					metye:0,
				},
				{
					label:"研发费用金额(万元)",
					name:'researchDevelopmentAmount',
					type:"A,B,C,D",
					ifChange:false,
					metye:0,
				},
				{
					label:"研发人员(名)",
					name:'researchDevelopmentPersonnel',
					type:"A,B,C,D",
					ifChange:false,
					metye:0,
				},
				{
					label:"职工总数(名)",
					name:'totalNumberEmployees',
					type:"A,B,C,D",
					ifChange:false,
					metye:0,
				},
				{
					label:"发明专利授权量(件)",
					name:'inventionPatentNumber',
					type:"A,B,C,D",
					ifChange:false,
					metye:0,
				},
				{
					label:"截止目前国际专利（PCT）授权量(件)",
					name:'pctPatentLicensing',
					type:"A,B,C,D",
					ifChange:false,
					metye:0,
				},
				{
					label:"软件著作权,实用新型授权量(件)",
					name:'newSoftwareLicenseNumber',
					type:"A,B,C,D",
					ifChange:false,
					metye:0,
				},
				{
					label:"技术合同成交额(万元)",
					name:'technicalContractTurnover',
					type:"A,B,C,D",
					ifChange:false,
					metye:0,
				},
				{
					label:"是否科技型中小企业",
					name:'scienceTechnologySmes',
					type:"A,B,C",
					ifChange:false,
					metye:1,
				},
				{
					label:"是否高新技术企业",
					name:'highTechEnterprise',
					type:"A,B,C,D",
					ifChange:false,
					metye:1,
				},
				{
					label:"高新技术产品(服务)收入(万元)",
					name:'incomeFromhighTechProducts',
					type:"A,B,C,D",
					ifChange:false,
					metye:0,
				},
				{
					label:"去年净利润金额(万元)",
					name:'netProfitAmount',
					type:"B,C,D",
					ifChange:false,
					metye:0,
				},
				{
					label:"前年净利润金额(万元)",
					name:'yearBeforeNetProfitAmount',
					type:"B,C,D",
					ifChange:false,
					metye:0,
				},
				{
					label:"去年净资产金额(万元)",
					name:'netAssetAmount',
					type:"A,B,C,D",
					ifChange:false,
					metye:0,
				},
				{
					label:"前年净资产金额(万元)",
					name:'yearBeforeNetAssetAmount',
					type:"A,B,C,D",
					ifChange:false,
					metye:0,
				},
				{
					label:"是否展翼企业",
					name:'spreadWingEnterprise',
					type:"C,D",
					ifChange:true,
					metye:1,
				},
				{
					label:"是否瞪羚企业",
					name:'gazelleEnterprise',
					type:"C,D",
					ifChange:true,
					metye:1,
				},
				{
					label:"是否规上企业",
					name:'lvEnterprises',
					type:"C,D",
					ifChange:true,
					metye:1,
				},
				{
					label:"是否专精特新企业",
					name:'specializedSpecialNewEnterprise',
					type:"C,D",
					ifChange:true,
					metye:1,
				},
				{
					label:"是否专精特新小巨人企业",
					name:'specializedSpecialNewSmallGiantEnterprise',
					type:"C,D",
					ifChange:true,
					metye:1,
				},
				{
					label:"当年吸纳高校应届毕业生人数",
					name:'freshCollegeGraduatesNumber',
					type:"A,B,C,D",
					ifChange:false,
					metye:0,
				},
				{
					label:"近两年是否承担建设国家、省、市研发或创新平台",
					name:'researchDevelopmentPlatform',
					type:"A,B,C,D",
					ifChange:false,
					metye:2,
				},
				{
					label:"近两年是否承担国家、省、市科技计划项目",
					name:'scienceTechnologyProject',
					type:"A,B,C,D",
					ifChange:false,
					metye:2,
				},
				{
					label:"近两年是否承担国家、地方企业标准制定",
					name:'enterpriseStandardSetting',
					type:"D",
					ifChange:false,
					metye:4,
				},
				{
					label:"获得省级及以上创新创业大赛",
					name:'innovationEntrepreneurshipCompetition',
					type:"A,B,C,D",
					ifChange:false,
					metye:3,
				},
				{
					label:"获得投资风险金额(万元)",
					name:'riskVentureFunds',
					type:"A,B,C,D",
					ifChange:false,
					metye:0,
				},
				{
					label:"发生重大安全生产事故",
					name:'majorWorkplaceSafetyAccidents',
					type:"A,B,C,D",
					ifChange:false,
					metye:1,
				},
				{
					label:"发生严重环保违法行为",
					name:'seriousEnvironmentalViolations',
					type:"A,B,C,D",
					ifChange:false,
					metye:1,
				},
				{
					label:"统计造假，经统计部门查处形成形成统计违法违纪案件",
					name:'statisticsIllegalDisciplinaryCases',
					type:"A,B,C,D",
					ifChange:false,
					metye:1,
				},
				{
					label:"存在其他严重失信行为",
					name:'grossBreachTrust',
					type:"A,B,C,D",
					ifChange:false,
					metye:1,
				},

				{
					label:"营业收入增长率(%)",
					name:'revenueGrowthRate',
					type:"A,B,C,D",
					ifChange:false,
					metye:0,
				},
				{
					label:"高新技术产品收入占营业收入比例",
					name:'proportionRevenueProducts',
					type:"A,B,C,D",
					ifChange:false,
					metye:0,
				},
				{
					label:"净利润增长率(%)",
					name:'netProfitGrowthRate',
					type:"B,C,D",
					ifChange:false,
					metye:0,
				},
				{
					label:"净资产增长率(%)",
					name:'netWorthGrowthRate',
					type:"A,B,C,D",
					ifChange:false,
					metye:0,
				},
		],
			form: {
				parentId: null,
			},
		}
	},
}
</script>
<style scoped lang="less"></style>
